import { AppFilePicker } from 'components';
import { memo } from 'react';

function UploadBackDrop({ data = {}, closeModal, handleSave }) {
  const { openUploadModal } = data;
  const open = !!openUploadModal.currentBlock;

  function handleFile(uploadData = {}) {
    handleSave(
      {
        assetUri: uploadData?.meta?.file,
        assetUrl: uploadData?.meta?.fullPath,
        currentBlock: openUploadModal.currentBlock,
      },
      openUploadModal.block
    );
  }
  return (
    <>
      <div
        className={`modal fade app-l-modal uploaddialog ${open ? 'show' : ''}`}
        id="UploadBackDropModal"
        tabIndex="-1"
        aria-labelledby="UploadBackDropModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered uploaddialog">
          <div className="modal-content p-5">
            <div className="modal-body">
              <h2 className="mb-3">
                {config[openUploadModal.currentBlock]?.heading ?? 'Select an item to upload'}
              </h2>
              <p>
                {config[openUploadModal.currentBlock]?.acceptedFormats?.length > 0 ? (
                  <>
                    Accepted formats:{' '}
                    {config[openUploadModal.currentBlock]?.acceptedFormats?.map?.((x) => `*${x},`)}
                  </>
                ) : (
                  <>All formats accepted</>
                )}
              </p>
            </div>
            <div className="modal-footer">
              <AppFilePicker
                accept={config[openUploadModal.currentBlock]?.acceptedFormats || ''}
                handleChange={handleFile}
                inputProps={{ accept: config[openUploadModal.currentBlock]?.acceptedFormats || '' }}
                referenceKey="REVISION_NOTE"
              >
                <div role="button" className="btn btn-primary" id="uploadBkDropModalID">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30.605"
                      height="24.147"
                      viewBox="0 0 30.605 24.147"
                    >
                      <path
                        id="Icon_material-computer"
                        data-name="Icon material-computer"
                        d="M25.5,27.129a2.813,2.813,0,0,0,2.538-3.018l.013-15.092A2.823,2.823,0,0,0,25.5,6H5.1A2.823,2.823,0,0,0,2.55,9.018V24.111A2.823,2.823,0,0,0,5.1,27.129H0v3.018H30.605V27.129ZM5.1,9.018H25.5V24.111H5.1Z"
                        transform="translate(0 -6)"
                        fill="#fff"
                      ></path>
                    </svg>
                  </span>
                  From PC
                </div>
              </AppFilePicker>
              <button
                type="button"
                className="btn btn-primary cancelbtn"
                data-bs-dismiss="modal"
                onClick={closeModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}

const config = {
  image: {
    heading: 'Select an IMAGE',
    acceptedFormats: ['.png', '.jpg', '.jpeg', '.svg'],
  },
};

export default memo(UploadBackDrop);
